import { useMutation } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type CreateQuoteBody, type Quote } from '../prospects/types'

export function useCreateQuote ({ prospectId }: { prospectId: string }) {
  return useMutation<Quote, GrapeAPIErrorType, CreateQuoteBody>({
    mutationFn: async (data: CreateQuoteBody) => {
      const response = await fetchWithHeaders(
        `/api/web/quoting/prospects/${prospectId}/quotes`,
        {
          method: 'POST',
          body: JSON.stringify(data),
        }
      )
      const responseJson = await response.json()
      if (!response.ok) {
        const errors = responseJson
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return responseJson
    },
  })
}
